// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/7c850ebc/" + chunkId + "." + __webpack_require__.h() + ".v7c850ebc.js";
};